/** @format */

import axios from 'axios'

import Notify from '../../../../components/Commons/Notify'

import { ENV_COMMON, ENV_COUNTRY } from '../../../../components/Commons/Hooks/Variables/Enviroment'

export default async function CartBannersService() {
	let returnResponse
	await axios({
		method: 'GET',
		url: `${ENV_COMMON}/cart/${ENV_COUNTRY}`,
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				returnResponse = response.data.data.banners
			} else {
				Notify({
					title: `Error Banners Cart`,
					colorTitle: 'ph-main-notification-error-title',
					description: 'Imagenes no encontradas.',
					time: 3,
					image: 'error',
					placement: 'topRight',
				})
			}
		})
		.catch(() => {
			Notify({
				title: `Error Servicio SERVICE_CORE`,
				colorTitle: 'ph-main-notification-error-title',
				description: 'Problemas con el servicio, Banners Cart.',
				time: 3,
				image: 'error',
				placement: 'topRight',
			})
		})
	return returnResponse
}
